import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { ShippingCounter } from "../../components/shared/shippingCounter";
import mobileSearch from "../../assets/icon/search-green-ico.svg";
import mobileSearchOrange from "../../assets/icon/search-orange-ico.svg";
import mobileSearchClose from "../../assets/icon/search-close.svg";
import mobileSearchCloseOrange from "../../assets/icon/search-close-orange.svg";
import decode from "jwt-decode";

import { useSelector, useDispatch } from "react-redux";
import { getCart, getCount } from "../../actions/cart";
import {
  getProductsv2,
  getFavProductsv2,
  getPreferred,
  getShortDated,
  getSalesPrices,
} from "../../actions/products";

// import ProfilePic from "../../assets/img/Account/placeholder-dp.svg";
import { getAvatar } from "../../actions/account";
// import { getSearch } from "../../actions/products";
import { getCustomProducts } from "../../actions/admin";
import PPLogo from "../../assets/img/pp-logo.svg";
import styled from "styled-components";
import fuzzysort from "fuzzysort";

export const StyledNav = styled.nav`
    ${props => props.brand && `
        .desktop-link:hover,
        .desktop-link a:hover {
            color: ${props.brand.colors.theme} !important;
        }

        .header {
          background: ${props.brand.colors.headerScrolled} !important;
        }

        .header.scrolled {
            background: ${props.brand.colors.headerScrolled} !important;
        }

        .login-btn {
            background: ${props.brand.colors.theme} !important;
            border: 1px solid ${props.brand.colors.theme} !important;
        }

        .account-btn {
            border: 2px solid ${props.brand.colors.myAccount.text} !important;

            p {
                color: ${props.brand.colors.myAccount.text} !important;
            }
        }

        .cart-btn {
            .count {
                background: ${props.brand.colors.cartCount} !important;
            }
        }
        @media (max-width: 1160px) {
        /* Hide the desktop-link on smaller screens */
       .desktop-link {
        display: none;
      }
      .burger-btn{
        display: flex !important;
      }
    }
    `}
`;

export const HeaderNav = () => {
  const [scrolled, setScrolled] = useState(false);

  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [user, setUser] = useState(null);
  const account = useSelector((state) => state.account);
  const { brand } = account;

  const cart = useSelector((state) => state.cart);
  const search = useSelector((state) => state.search);
  const admin = useSelector((state) => state.admin);
  const avatar = useSelector((state) => state.account.avatarData);
  const productsData = useSelector((state) => state.products);
  const [formData, setFormData] = useState({});
  const [searchName, setSearchName] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchResults, setsearchResults] = useState(null);
  const [searchActive, setSearchActive] = useState();
  const searchInput = useRef(null);
  const itemCount =
    cart.cartData?.length > 0
      ? cart.cartData
        .map((item) => parseInt(item.quantity))
        .reduce((prev, next) => prev + next)
      : 0;

  const searchRedirect = (id) => {
    history.push(`/product/${id}`);
  };

  const resetInputField = () => {
    searchInput.current.value = "";
    setTimeout(() => {
      var element = document.getElementById("resultBoxMobile");
      element.classList.remove("d-block");
      element.classList.add("d-none");
    }, 100);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    history.push(`/search?name=${formData.name}`);
  };

  const handleChange = (e) => {
    setSearchLoading(true);
    var element = document.getElementById("resultBox");
    if (element) element.style.display = "block";
    setFormData({ [e.target.name]: e.target.value });
    setSearchName(e.target.value);
  };

  const handleChangeMobile = (e) => {
    setSearchLoading(true);
    var element = document.getElementById("resultBoxMobile");
    if (element) element.style.display = "block";
    setFormData({ [e.target.name]: e.target.value });
    setSearchName(e.target.value);
  };

  const handleMouseEnter = () => {
    var element = document.getElementById("resultBox");
    var mobileElement = document.getElementById("resultBoxMobile");
    if (element) {
      element.style.display = "block";
    }
    if (mobileElement) {
      mobileElement.style.display = "block";
    }
  };

  const handleMouseLeave = (e) => {
    var element = document.getElementById("resultBox");
    var mobileElement = document.getElementById("resultBoxMobile");
    if (element) {
      element.style.display = "none";
    }
    if (mobileElement) {
      mobileElement.style.display = "none";
    }
  };

  useEffect(() => {
    if (brand) {
      try {
        const localUser = JSON.parse(localStorage.getItem("profile"));
        const token = localUser?.accessToken;
        
        // Enhanced token validation with buffer
        if (token) {
          try {
            const decodedToken = decode(token);
            const currentTime = Date.now() / 1000; // Convert to seconds
            
            // Add 5 minute buffer before expiration - only logout if truly expired
            if (decodedToken.exp <= (currentTime + 300)) {
              setUser(null);
              localStorage.removeItem('profile');
              return;
            }
          } catch (tokenError) {
            console.warn('Invalid token format:', tokenError);
            setUser(null);
            localStorage.removeItem('profile');
            return;
          }
        }
        
        if (localUser && token) {
          setUser(localUser);
          dispatch(getCart(localUser?.username));
          dispatch(getCount(localUser?.username));
          dispatch(getAvatar(localUser?.username));
          sendWebflowData();
        } else if (!localUser) {
          setUser(null);
        }
        
        setFormData({ ...formData, name: "" });

        if (
          ["shop", "search", "product"].includes(location.pathname.split("/")[1]) &&
          !admin?.customProducts
        ) {
          if (localUser && token) {
            brand && brand.region && dispatch(getCustomProducts(localUser?.username, brand?.region));
          }
        }
      } catch (error) {
        console.warn('Error parsing profile from localStorage:', error);
        setUser(null);
        localStorage.removeItem('profile');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, brand]);

  useEffect(() => {
    setsearchResults(search);
    setSearchLoading(false);
  }, [search]);

  useEffect(() => {
    function handleScroll() {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    let searchResult, changeTimer;

    if (searchName !== "") {
      changeTimer = setTimeout(() => {
        searchResult = fuzzysort.go(searchName, productsData.productsv2, {
          keys: ["name", "ndc"],
        });

        setsearchResults(searchResult);
        setSearchLoading(false);
      }, 1000);
    }

    return () => {
      clearTimeout(changeTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchName]);

  useEffect(() => {
    if (brand) {
      const auth = JSON.parse(localStorage.getItem("profile"));
      if (
        ["shop", "search", "product"].includes(location.pathname.split("/")[1])
        && !productsData.count && brand
      ) {
        dispatch(getProductsv2(brand.region));
        dispatch(getSalesPrices(brand.region));
        if (auth) {
          dispatch(getFavProductsv2(auth?.username, brand.region));
          dispatch(getPreferred(auth?.username));
        }
        dispatch(getShortDated(brand.region));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brand]);

  const sendWebflowData = () => {
    try {
      const cartIFrame = document.getElementById("hidden-iframe");
      if (!cartIFrame || !cartIFrame.contentWindow) return;
      
      const targetOrigin = process.env[brand?.homePageUrlKey];
      if (!targetOrigin) return;
      
      // Check if we're in development and trying to post to production
      const isDevelopment = window.location.hostname === 'localhost';
      const isTargetProduction = targetOrigin.includes('https://');
      
      // Skip postMessage in development when targeting production
      if (isDevelopment && isTargetProduction) {
        console.info('Skipping cross-origin postMessage in development');
        return;
      }
      
      if (location.pathname === "/login" || location.pathname === "/register") {
        cartIFrame.contentWindow.postMessage(
          null,
          targetOrigin
        );
      } else {
        if (brand) {
          const avatarData = avatar !== "" && !Array.isArray(avatar)
            ? avatar
            : brand.metaData.webFlowDPUrl;

          const sendData = { ...user, avatarData, cartCount: itemCount };

          cartIFrame.contentWindow.postMessage(
            sendData,
            targetOrigin
          );
        }
      }
    } catch (error) {
      // Silently handle postMessage errors in development
      if (window.location.hostname !== 'localhost') {
        console.error('Error sending webflow data:', error);
      }
    }
  };

  return (
    <StyledNav
      brand={brand}
      className={
        location.pathname === "/login" || location.pathname === "/register"
          ? "navbar header-login header"
          : "fixed-top"
      }
    >
      <iframe
        id="hidden-iframe"
        src={brand && process.env[brand.homePageUrlKey]}
        height="200"
        width="300"
        title="Iframe Example"
        onLoad={sendWebflowData}
      />
      {location.pathname === "/login" || location.pathname === "/register" ? (
        <a href={brand && process.env[brand.homePageUrlKey]}>
          <img
            className="logo"
            src={brand?.icons.headerLogo ? brand?.icons.headerLogo : PPLogo}
            width="152.25"
            height="46.49"
            alt=""
          />
        </a>
      ) : (
        <>
          <ShippingCounter
            brand={brand}
            cart={cart}
            path={location.pathname}
          />

          <div
            brand={brand}
            className={`navbar d-flex align-items-center header main ${scrolled ? " scrolled" : ""}`}>
            <a href={brand && process.env[brand.homePageUrlKey]}>
              <img
                className="logo"
                src={brand?.icons.headerLogo}
                width="182"
                height="26.15"
                alt=""
              />
            </a>
            <div className="d-flex align-items-center justify-content-end right-col">
              <a
                className="desktop-link"
                href={`${brand && process.env[brand.homePageUrlKey]}/aboutus`}
              >
                About
              </a>
              <div className="desktop-link dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#!"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Products
                </a>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                  {user && (
                    <Link
                      className="dropdown-item"
                      to="/shop?category=Favorites"
                    >
                      My Favorites
                    </Link>
                  )}
                  {/* <Link
                    className="dropdown-item"
                    to="/shop?category=Weekly Specials"
                  >
                    Weekly Specials
                  </Link> */}
                  <Link className="dropdown-item" to="/shop?category=Specials">
                    Short Dated
                  </Link>
                  <Link
                    className="dropdown-item"
                    to="/shop?category=Pharmaceuticals"
                  >
                    Pharmaceuticals
                  </Link>
                  <Link
                    className="dropdown-item"
                    to="/shop?category=Animal Health"
                  >
                    Animal Health
                  </Link>
                  <Link
                    className="dropdown-item"
                    to="/shop?category=Medical Supplies"
                  >
                    Medical/Surgical
                  </Link>
                  {/* {brand && brand.name === "premierpharma" && <Link
                    className="dropdown-item"
                    to="/shop?category=Smoking Cessation"
                  >
                    Smoking Cessation 
                  </Link>} */}
                  {brand && brand.name === "premierpharma" && <Link
                    className="dropdown-item"
                    to="/shop?category=Premier's Choice"
                  >
                    Premier's Choice
                  </Link>}  
                  {brand && brand.name === "premierpharma" && <Link
                    className="dropdown-item"
                    to="/shop?category=Year End Sale"
                  >
                    Year End Sale
                  </Link>}              
                </div>
              </div>
              <a
                className="desktop-link"
                href={`${brand && process.env[brand.homePageUrlKey]}/contact-us`}
              >
                Contact
              </a>
              {brand && brand.name === "premierpharma" &&
                <a
                  className="desktop-link"
                  href={`${brand && process.env[brand.homePageUrlKey]}/consulting`}
                >
                  Consulting
                </a>}

              {brand && brand.name === "premiermid-america" &&
                <a
                  className="desktop-link"
                  href={`${brand && process.env[brand.homePageUrlKey]}/careers`}
                >
                  Careers
                </a>}
              {brand && brand.name !== "premiermid-america" && <a
                className="desktop-link"
                href={`${brand && process.env[brand.homePageUrlKey]}/faq`}
              >
                FAQ
              </a>}
              <div className="desktop-link dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#!"
                  id="salesDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Contact Sales
                </a>
                <div className="dropdown-menu" aria-labelledby="salesDropdown">
                  <a className="dropdown-item" href="mailto:christian@premierpharma.com">
                    Christian
                  </a>
                  <a className="dropdown-item" href="mailto:jake@premierpharma.com">
                    Jake
                  </a>
                </div>
              </div>
              <div
                className="search-container"
                onMouseLeave={() => {
                  formData.name && formData.name.length === 0 && handleMouseLeave()
                }}
                onMouseEnter={handleMouseEnter}
              >
                <form onSubmit={handleSubmit}>
                  <input
                    name="name"
                    value={formData.name || ""}
                    placeholder="Search Products..."
                    onChange={handleChange}
                    autoComplete="off"
                  />
                </form>
                {formData.name && formData.name !== "" && (
                  <ul id="resultBox" className="results">
                    {searchLoading && (
                      <li>
                        <p>Searching products...</p>
                      </li>
                      //   <li>
                      //     <div className="spinner-container d-flex align-items-center justify-content-center">
                      //       <div
                      //         className="spinner-border text-primary"
                      //         role="status"
                      //       >
                      //         <span className="sr-only">Loading...</span>
                      //       </div>
                      //     </div>
                      //   </li>
                    )}
                    {!searchLoading &&
                      searchResults.length > 0 &&
                      searchResults.map((searchResult) => (
                        <li
                          key={searchResult.obj.id}
                          onClick={() => searchRedirect(searchResult.obj.id)}
                        >
                          <p>{searchResult.obj.name}</p>
                        </li>
                      ))}
                    {!searchLoading && searchResults.length === 0 && (
                      <li>
                        <p>Product Not Found</p>
                      </li>
                    )}
                  </ul>
                )}
              </div>

              <div className="divider d-none d-md-block"></div>

              {user ? (
                <>
                  <Link
                    brand={brand}
                    to="/cart" className="cart-btn">
                    <div className="d-flex flex-row align-items-center justify-content-center">
                      <div className="d-flex flex-row align-items-center justify-content-center">
                        <img src={brand?.icons.cartIcon} alt="" width="27.5" height="27.5" />
                        <p className="m-0 ml-3 d-none d-md-none">My Cart</p>
                        <div className="count ml-3">{itemCount}</div>
                      </div>
                    </div>
                  </Link>
                  <div className="mobile-search-div">
                    {searchActive ? (
                      <img
                        src={brand && brand?.name !== 'premiermid-america' ? mobileSearchClose : mobileSearchCloseOrange}
                        onClick={() => setSearchActive(false)}
                        alt="Search Close"
                      />
                    ) : (
                      <img
                        src={brand && brand?.name !== 'premiermid-america' ? mobileSearch : mobileSearchOrange}
                        onClick={() => setSearchActive(true)}
                        alt="Search Open"
                      />
                    )}
                  </div>
                  <Link
                    brand={brand}
                    to="/account"
                    className="account-btn d-none d-md-block">
                    <div className="profileWrapper d-flex flex-row align-items-center justify-items-center">
                      {avatar !== "" && !Array.isArray(avatar) ? (
                        <img className="profilePic" src={avatar} alt="Avatar" />
                      ) : (
                        <img className="profilePic" src={brand?.icons.avatar} alt="" />
                      )}
                      <p className="m-0 ml-3">My Account</p>
                    </div>
                  </Link>
                  <Link to="/account" className="account-btn-icon-only d-block d-md-none">
                    <div className="profileWrapper d-flex flex-row align-items-center justify-items-center">
                      {avatar !== "" && !Array.isArray(avatar) ? (
                        <img className="profilePic" src={avatar} alt="Profile" />
                      ) : (
                        <img className="profilePic" src={brand?.icons.avatar} alt="" />
                      )}
                    </div>
                  </Link>
                </>
              ) : (
                <>
                  <div className="mobile-search-div">
                    {searchActive ? (
                      <img
                      src={brand?.icons.mobileSearchClose}
                        onClick={() => setSearchActive(false)}
                        alt="Search Close"
                      />
                    ) : (
                      <img
                      src={brand?.icons.mobileSearch}
                        onClick={() => setSearchActive(true)}
                        alt="Search Open"
                      />
                    )}
                  </div>
                  <Link
                    brandcolor={brand?.colors.theme}
                    to="/login" className="login-btn">
                    Login
                  </Link>
                </>
              )}

              <div className="dropdown burger-btn">
                <a
                  className="dropdown-toggle"
                  href="#!"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <img src={brand && brand.icons.mobileMenu} alt="" />
                </a>
                <div
                  className="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbarDropdown"
                >
                  <Link
                    className="dropdown-item"
                    href={`${brand && process.env[brand.homePageUrlKey]}/about-us`}
                    to=""
                  >
                    About Us
                  </Link>
                  <hr />
                  <ul>
                    <p>Products</p>
                    {user && (
                      <li>
                        <Link
                          className="dropdown-item"
                          href="#!"
                          to="/shop?category=Favorites"
                        >
                          My Favorites
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link
                        className="dropdown-item"
                        href="#!"
                        to="/shop?category=Pharmaceuticals"
                      >
                        Pharmaceuticals
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        href="#!"
                        to="/shop?category=Animal Health"
                      >
                        Animal Health
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        href="#!"
                        to="/shop?category=Medical Supplies"
                      >
                        Medical/Surgical
                      </Link>
                    </li>
                    {/* {brand && brand.name === "premierpharma" && <li>
                  <Link
                    className="dropdown-item"
                    href="#!"
                    to="/shop?category=Smoking Cessation"
                  >
                    Smoking Cessation 
                  </Link>
                    </li>} */}
                  {brand && brand.name === "premierpharma" && <li>
                  <Link
                    className="dropdown-item"
                    href="#!"
                    to="/shop?category=Premier's Choice"
                  >
                    Premier's Choice 
                  </Link>
                    </li>}
                  {brand && brand.name === "premierpharma" && <li>
                  <Link
                    className="dropdown-item"
                    href="#!"
                    to="/shop?category=Year End Sale"
                  >
                    Year End Sale 
                  </Link>
                    </li>}                    
                  </ul>
                  <hr />
                  <Link
                    className="dropdown-item"
                    href={`${brand && process.env[brand.homePageUrlKey]}/contact-us`}
                    to=""
                  >
                    Contact Us
                  </Link>
                  <hr />
                  <ul>
                    <p>Contact Sales</p>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mailto:christian@premierpharma.com"
                      >
                        Christian
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="mailto:jake@premierpharma.com"
                      >
                        Jake
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {searchActive && (
              <div
                className="w-100 align-items-center text-center mobile-search position-relative"
                onMouseLeave={handleMouseLeave}
                onMouseEnter={handleMouseEnter}
              >
                <form onSubmit={handleSubmit}>
                  <img
                    src={brand?.icons.SearchClear}
                    className="clear-search"
                    onClick={resetInputField}
                  />
                  <input
                    name="name"
                    value={formData.name || ""}
                    placeholder="Search Products..."
                    ref={searchInput}
                    autoComplete="off"
                    onChange={handleChangeMobile}
                    style={{ backgroundImage: `url(${brand?.icons.mobileSearch})` }}
                  />
                </form>
                {formData.name && formData.name !== "" && (
                  <ul id="resultBoxMobile" className="results">
                    {searchLoading && (
                      <li>
                        <p>Searching products...</p>
                      </li>
                    )}
                    {!searchLoading &&
                      searchResults.length > 0 &&
                      searchResults.map((product) => (
                        <li
                          key={product.obj.id}
                          onClick={() => searchRedirect(product.obj.id)}
                        >
                          <p>{product.obj.name}</p>
                        </li>
                      ))}
                    {!searchLoading && searchResults.length === 0 && (
                      <li>
                        <p>Product Not Found</p>
                      </li>
                    )}
                  </ul>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </StyledNav>
  );
};
